const chains = [];
chains.push({ _operation: 'createPaymentSystemRelationship', api: '/payment-system-relationship', defaultData: null, httpVerb: 'post' });
chains.push({ _operation: 'deletePaymentSystemRelationshipById', api: '/payment-system-relationship/:objectId', defaultData: null, httpVerb: 'delete' });
chains.push({ _operation: 'getPaymentSystemRelationships', api: '/payment-system-relationships', defaultData: [], httpVerb: 'get' });
export default chains;
